import moment from 'moment'

export function datesInWeekOf(date) {
  return Array(7).fill(null).map((day, index) => moment(date).isoWeekday(index+1).startOf('day'))
}

export function dateKey(date) {
  return date.format('D-M-YY')
}

export function formatDate(m) {
  return m.format('YYYY-MM-DD')
}

export function elapsedTime(ms) {
  return moment.utc(ms).format('HH:mm:ss')
}

export function roundMsToQuarterHours(ms) {
  return Math.round((ms / 3600000) / 0.25) * 0.25
}